export enum ComplianceTranslateKey {
  OTHER_ELEMENTS = 'sections.forms.otherElements',
  DOCUMENTARY_COMPLIANCE = 'compliances.mainTitle',
  DOCUMENTARY_COMPLIANCE_SHORT = 'compliances.shortTitle',
  SUB_TITLE = 'compliances.subTitle',
  COMPLIANCE_LIST_DESCRIPTION = 'compliances.listDescription',
  COMPLIANCE_NOTIF_DESCRIPTION = 'compliances.notificationDescription',
  COMPLIANCE_DELETE_DESCRITION = 'compliances.deleteDescription',
  COMPLIANCE_DELETE_TITLE = 'compliances.deleteTitle',
  SEE_ALL_DOCUMENTS = 'compliances.actions.seeAllDocuments',
  CREATE_PLAN = 'compliances.actions.createPlan',
  PLAN_NAME = 'compliances.planName',
  EMPLOYEES = 'compliances.dialog.employees',
  DEPARTMENT_PERSON_CONCERNED = 'compliances.departmentPersonConcerned',
  NUMBER_DOCUMENTS = 'compliances.numberDocuments',
  EMPTY_MESSAGE = 'compliances.emptyMessage',
  EMPTY_DOCUMENTS = 'compliances.emptyDocuments',
  EMPTY_EMPLOYEES = 'compliances.emptyEmployees',
  CREATION_PLAN_TITLE = 'compliances.dialog.creationTitle',
  CREATION_PLAN_DESCRIPTION = 'compliances.dialog.creationDescription',
  EDIT_PLAN_TITLE = 'compliances.dialog.editPlanTitle',
  EDIT_PLAN_DESCRIPTION = 'compliances.dialog.editPlanDescription',
  PLAN_NAME_PLACEHOLDER = 'compliances.dialog.planNamePlaceholder',
  DEPARTMENTS_OR_PERSONS = 'compliances.dialog.departmentsOrPersons',
  DEPARTMENTS_OR_PERSONS_PLACEHOLDER = 'compliances.dialog.departmentsOrPersonsPlaceholder',
  PLAN_DOCUMENTS = 'compliances.dialog.planDocuments',
  PLAN_DOCUMENTS_PLACEHOLDER = 'compliances.dialog.planDocumentsPlaceholder',
  NO_SELECTED_DOCUMENTS = 'compliances.dialog.noSelectedDocuments',
  SELECTED_DOCUMENTS = 'compliances.dialog.selectedDocuments',
  OBLIGATORY = 'compliances.dialog.obligatory',
  DELETE = 'forms.buttons.delete',
  GENERAL_INFO = 'compliances.dialog.generalInfo',
  PLAN_BROADCASTED = 'compliances.dialog.planBroadcasted',
  BROADCAST = 'compliances.dialog.broadcast',
  BROADCAST_SHORT = 'compliances.actions.broadcastShort',
  EDIT = 'forms.buttons.edit',
  BROADCAST_TITLE = 'compliances.dialog.broadcastTitle',
  BROADCAST_DESCRIPTION = 'compliances.dialog.broadcastDescription',
  BROADCAST_BUTTON = 'compliances.actions.broadcast',
  SELECT_PLACEHOLDER = 'compliances.dialog.selectPlaceholder',
  DISTRIBUTE_LIST = 'compliances.dialog.distributeList',
  CONTINUE = 'forms.buttons.continue',
  NOTIFICATION_OPTION = 'compliances.dialog.notificationOption',
  NOTIFY_BY_MAIL = 'compliances.dialog.notificyByMail',
  SAVE_PLAN = 'compliances.dialog.savePlan',
  BACK = 'compliances.dialog.back',
  CREATED_MESSAGE = 'compliances.dialog.created',
  EDITED_MESSAGE = 'compliances.dialog.edited',
  DOCUMENT_LIST = 'compliances.documentList',
  DOCUMENT_NAME = 'compliances.documentName',
  DOC_NAME_PLACEHOLDER = 'compliances.documentNamePlaceholder',
  DOCUMENT_DETAILS = 'compliances.documentDetails',
  DOCUMENT_DUE_DATE = 'compliances.dueDate',
  ADD_DOCUMENT = 'forms.buttons.addDocument',
  EDIT_DOCUMENT = 'compliances.actions.editDocument',
  ADDING_DOCUMENT = 'compliances.addingDocument',
  ADDING_DOC_DESCRIPTION = 'compliances.addingDocumentDescription',
  EDITING_DOCUMENT = 'compliances.editingDocument',
  EDITING_DOC_DESCRIPTION = 'compliances.editingDocumentDescription',
  CORRESPONDING_SECTION = 'compliances.correspondingSection',
  CORRESPONDING_SECTION_DESC = 'compliances.correspondingSectionDesc',
  ACCEPTED_FORMATS = 'compliances.acceptedFormats',
  ACCEPTED_FORMATS_DESC = 'compliances.acceptedFormatsDesc',
  EXPIRATION_DATE = 'compliances.expirationDate',
  EXPIRATION_TRACKING = 'compliances.expirationTracking',
  EXPIRATION_TRACKING_DESCRITION = 'compliances.expirationTrackingDescription',
  DOCUMENTARY_PLAN_DETAILS = 'compliances.documentaryPlanDetails',
  YES = 'forms.titles.yes',
  NO = 'forms.titles.no',
  EDIT_PLAN = 'compliances.editPlan',
  DELETE_PLAN = 'compliances.deletePlan',
  MATRICULE = 'employees.list.table.head.identityNumber',
  FIRSTNAME = 'employees.profile.firstName',
  LASTNAME = 'employees.profile.lastName',
  DEPARTMENT = 'compliances.department',
  STATUS = 'contracts.forms.titles.status',
  DELETE_PLAN_PLACEHOLDER = 'compliances.dialog.deletePlanPlaceholder',
  DELETE_PLAN_CONFIRM = 'compliances.dialog.deleteConfirm',
  LOAD_MORE = 'compliances.actions.loadMore',
  AFFECTED_EMPLOYEES = 'compliances.affectedEmployees',
  DOCUMENT_ADDED = 'compliances.dialog.documentAdded',
  DOCUMENT_EDITED = 'compliances.dialog.documentEdited',
  DOCUMENT_REMOVED = 'compliances.dialog.documentRemoved',
  PLAN_REMOVED = 'compliances.dialog.planRemoved',
  PLAN_EDITED = 'compliances.dialog.planEdited',
  PLAN_CREATED = 'compliances.dialog.planCreated',
  ERROR_OCCURED = 'compliances.dialog.errorOccured',
  RELAUNCH = 'forms.buttons.relaunch',
  EMPLOYEE_RELAUNCHED = 'compliances.employeeRelaunched',
  COMPLETE = 'compliances.complete',
  UNCOMPLETE = 'compliances.uncomplete',
  SECTION_PLAN_REMOVED = 'compliances.sectionPlanRemoved',
}
